import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import RideApi from "Services/Ride";

const RideWaypointDeleteModal = ({ openDialog, waypointId, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    if (!waypointId) {
      dispatch(
        showSnackbar({
          message: "Waypoint ID not found",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
      return;
    }

    dispatch(showLoader("Loading please wait..."));
    RideApi.deleteRideWaypoint(waypointId).then(
      () => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: "Ride waypoint deleted successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        handleClose(true);
      },
      (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: err?.response?.data?.message || "Error while deleting ride waypoint",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "error",
          })
        );
      }
    );
  };

  return (
    <Dialog open={openDialog} onClose={() => handleClose(false)} fullWidth maxWidth="xs">
      <DialogTitle>{"Are you sure delete this ride waypoint ?"}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Waypoint ID: {waypointId || "-"}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Disagree</Button>
        <Button onClick={handleDelete} autoFocus>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RideWaypointDeleteModal;
